import React from "react"
import { useSiteMetadata } from "../hooks/useSiteMetadata"

export const SEO = ({ title = "", description = "", image = "", children = undefined }) => {

  const { 
    title: defaultTitle, 
    description: defaultDescription, 
    image: defaultImage, 
    siteUrl, 
    twitterUsername, 
    siteName, 
    twitterCreator 
  } = useSiteMetadata()

  const pathname = typeof window !== `undefined` && window.location.pathname;

  const seo = {
    title: `${title ? `${title} |` : ``} ${defaultTitle}`,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  }

  const metas = [
    {
      name: 'description',
      content: description || defaultDescription,
    },
    {
      name: 'image',
      content: image || defaultImage,
    },
    {
      name: 'og:image',
      content: image || defaultImage,
    },
    !image ? {
      name: 'og:image:width',
      content: `1200`,
    } : {},
    !image ? {
      name: 'og:image:height',
      content: `630`,
    } : {},
    {
      name: 'og:type',
      content: 'website',
    },
    {
      name: 'og:title',
      content: `${title ? `${title} |` : ``} ${defaultTitle}`,
    },
    {
      name: 'og:description',
      content: description || defaultDescription,
    },
    {
      name: 'og:site_name',
      content: siteName,
    },
    {
      name: 'og:url',
      content: `${siteUrl}${pathname || ``}`,
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:description',
      content: description || defaultDescription,
    },
    {
      name: 'twitter:title',
      content: `${title ? `${title} |` : ``} ${defaultTitle}`,
    },
    {
      name: 'twitter:image',
      content: image || defaultImage,
    },
    {
      name: 'twitter:creator',
      content: twitterCreator,
    },
  ];

  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "PipeLime",
    "url": "https://pipelime.ai",
    "logo": "https://pipelime.ai/images/logo.png",
    "sameAs": [
      "https://www.instagram.com/pipelime.ai",
      "https://www.linkedin.com/company/pipelime-ai",
      "https://www.tiktok.com/@pipelime.ai",
      "https://pipelime.ai"
    ]
  }

  return (
    <>
      <html lang="en" />
      <meta charSet="utf-8" />
      <title>{seo.title}</title>
      <script type="application/ld+json">{JSON.stringify(schemaOrg)}</script>
      {metas.filter(meta => !!meta.name).map(meta => (
        <meta key={meta.name} name={meta.name} content={meta.content} />
      ))}
      {children}
    </>
  )
}
